// extracted by mini-css-extract-plugin
module.exports = {"container":"confirmation-modal-content_container__AvJhS","title":"confirmation-modal-content_title__3wtXU","errorMessage":"confirmation-modal-content_errorMessage__j5xnQ"};